import { Injectable } from '@angular/core';
import { Actions, OnInitEffects, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { KegService } from 'app/services/dal/keg.service';
import { ToastService } from 'app/services/toast.service';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import * as Action from './actions'
import { Router } from '@angular/router';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromKeg from './reducer';




@Injectable()
export class KegEffects
// implements OnInitEffects
{



  // ngrxOnInitEffects() {
  //   return KegActions.loadItemsFromInitEffect;
  // }



  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store,
    private kegService: KegService,
    private toastService: ToastService) { }

  getKegs$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(
          Action.loadItems,
          Action.loadItemsFromInitEffect
        ),
        shouldLoadData(
          this.store,
          'kegs',
          (action) => action.barId,
          fromKeg.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'kegs',
            action.barId,
            this.kegService.getItems(action.barId).pipe(
              map(kegs => Action.loadItemsSuccess({ items: kegs })),
              catchError(error => of(Action.loadItemsFailure({ error })))
            )
          )
        )
      );
  });

  setItemFromListPage$ = createEffect(
    () => {
      return this.actions$
        .pipe(

          ofType(
            Action.setItemFromListPage,
            Action.setItemAndNavigate
          ),
          tap((action) => {
            this.router.navigate(['/inventory/kegs/details', action.id]);
          }),
        )
    },
    { dispatch: false }
  );


  updateKeg$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.updateItem),
        mergeMap((action) => from(this.kegService.update(action.item))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.updateItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.updateItemFailure({ error })))
          )
        )
      );
  });



  addKeg$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.addItem),
        mergeMap((action) => from(this.kegService.add(action.item, action.id))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.addItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });


  deleteKeg$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteItem),
        mergeMap((action) => from(this.kegService.delete(action.id))
          .pipe(
            map(() => {
              this.toastService.deleteItemSuccess();
              return Action.deleteItemSuccess();
            }),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });




  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdate),
        mergeMap((action) => from(this.kegService.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.softUpdateSuccess({ id: action.id, data: action.data })
            }),
            catchError((error) => {
              return of(Action.softUpdateFailure({ error }))
            })
          )
        )
      );
  });

  softUpdateSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdateSuccess),
        tap(() => {
          this.toastService.saveSuccess();
        }),
      );
  }, { dispatch: false });


  softUpdateFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdateFailure),
        tap(({ error }) => {
          this.toastService.error(JSON.stringify(error));
        })
      );
  }, { dispatch: false });



}
